import { Injectable } from '@angular/core';
import { userPermissions } from '../models/enums/user-permissions.enum';
import { ManagementApiService } from './management-api.service';
import { ErrorDialogComponent } from '../shared/info-dialogs/error-dialog/error-dialog.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FullUserData } from '../Modules/management/models/organization/fullUserData.model';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { BehaviorSubject } from 'rxjs';
import { UserSessions } from '../models/user-sessions-details';
import jwt_decode from 'jwt-decode';
import { UserPermissions } from '../Modules/management/models/organization/user-permissions.model';

@Injectable({
    providedIn: 'root',
})
export class UserUtilityService {
    userData: FullUserData;
    userPermissions: UserPermissions[];
    noneSelectedPassPct: boolean = false;
    userSessionData = new BehaviorSubject<UserSessions>(null);
    errorPopupCount = 0;

    constructor(
        private _managementApiService: ManagementApiService,
        private modalService: NgbModal,
        private router: Router,
        private authService: MsalService
    ) { }

    getUserData(): FullUserData {
        return this.userData;
    }

    setUserData(user: FullUserData) {
        this.userData = user;
    }

    getUserSecurityRoleName() {
        return this.userData.securityRoles[0].securityRole.name;
    }

    isLicenseValid(): boolean {
        return this.userData.license.isValid;
    }

    checkUserPermissionOnRoute(path: string, action: string): boolean {
        const real_path = userPermissions[path];

        if (this.userData?.license?.isValid) {
            if (
                this.userData.license.instanceTypeIndex == 1 ||
                this.userData.license.instanceTypeIndex == 3 ||
                this.userData.license.instanceTypeIndex == 2 ||
                this.userData.license.instanceTypeIndex == 3
            ) {
                //traverse on each permission
                if (this.userPermissions?.length) {
                    for (let i = 0; i < this.userPermissions?.length; i++) {
                        if (
                            this.userPermissions[i].path === real_path &&
                            this.userPermissions[i].action === action &&
                            this.userPermissions[i].allowed === true
                        ) {
                            return true;
                        }
                    }
                }
                return false;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }

    async checkUserPermissionDataAndRoute(path: string, action: string): Promise<boolean> {
        try {
            if (!this.userData) {
                const token = localStorage.getItem('msal.accessToken');
                const decodedToken: any = jwt_decode(token);
                const userDetailResponse = await this._managementApiService.getFullUserDetail(decodedToken.oid).toPromise();
                if (!userDetailResponse.success) {
                    if (this.errorPopupCount < 1) this.errorModelPopup(userDetailResponse.message);
                    this.errorPopupCount++;
                    return false;
                }
                this.userData = userDetailResponse.response;
            }

            if (!this.userPermissions) {
                const permissionsResponse = await this._managementApiService.getUserPermissions().toPromise();
                if (!permissionsResponse.success) {
                    if (this.errorPopupCount < 1) this.errorModelPopup(permissionsResponse.message);
                    this.errorPopupCount++;
                    return false;
                }
                this.userPermissions = permissionsResponse.response;
            }

            return this.checkUserPermissionOnRoute(path, action);
        } catch (error) {
            if (this.errorPopupCount < 1) this.errorModelPopup('An unexpected error occurred');
            this.errorPopupCount++;
            return false;
        }
    }

    async refreshProfileData() {
        const token = localStorage.getItem('msal.accessToken');
        const decodedToken: any = jwt_decode(token);
        const userDetailResponse = await this._managementApiService.getFullUserDetail(decodedToken.oid).toPromise();
        if (!userDetailResponse.success) {
            if (this.errorPopupCount < 1) this.errorModelPopup(userDetailResponse.message);
            this.errorPopupCount++;
            return false;
        }
        this.userData = userDetailResponse.response;
    }

    errorModelPopup(errorMessage) {
        let dialogRef = this.modalService.open(ErrorDialogComponent, {
            size: 'sm',
        });
        dialogRef.componentInstance.message = errorMessage;
        dialogRef.result
            .then((resp) => {
                if (resp) {
                    if (errorMessage == 'Current user does not exist.') {
                        this.logout();
                    }
                }
            })
            .catch((e) => {
                console.warn(e);
            });
    }
    errorModelPopupLg(errorMessage, messageAlternative) {
        let dialogRef = this.modalService.open(ErrorDialogComponent, {
            size: 'lg',
        });
        dialogRef.componentInstance.message = errorMessage;
        dialogRef.componentInstance.messageAlternative = messageAlternative;
        dialogRef.result
            .then((resp) => {
                if (resp) {

                }
            })
            .catch((e) => {
                console.warn(e);
            });
    }
    logout() {
        this.authService.logoutPopup();
        localStorage.clear();
        this.router.navigate(['/landing']);
    }
}
